/* ============================================================
   ART IDEA GENERATOR — Shopify Asset JavaScript
   Initialiseres pr. section-instans via data-section-id
   ============================================================ */

(function () {
  'use strict';

  // ─── 1. DATA ───────────────────────────────────────────────

  const primaries = [
    // Originale
    "Pillar", "Arch", "Dome", "Vault", "Plinth", "Slab", "Monolith", "Obelisk",
    "Tower", "Spire", "Scaffold", "Foundation", "Corridor", "Atrium", "Facade",
    "Balustrade", "Cornice", "Buttress", "Column", "Pedestal", "Lintel", "Gable",
    "Rotunda", "Portal", "Threshold", "Aperture", "Frame", "Grid", "Lattice",
    "Casing", "Enclosure", "Framework", "Structure", "Module", "Unit", "Basement",
    "Ziggurat", "Pyramid", "Amphitheater", "Altar", "Sarcophagus", "Cenotaph",
    "Monument", "Relic", "Artifact", "Capsule", "Container", "Vessel", "Crate",
    "Ribcage", "Skull", "Vertebrae", "Femur", "Spine", "Jaw", "Joint", "Nerve",
    "Artery", "Tendon", "Muscle", "Sinew", "Membrane", "Tissue", "Organ", "Heart",
    "Lung", "Brain", "Torso", "Anatomy", "Skeleton", "Fragment", "Segment",
    "Cocoon", "Shell", "Exoskeleton", "Carapace", "Wing", "Antenna", "Scale",
    "Skin", "Fiber", "Root", "Stem", "Petal", "Thorn", "Seed", "Pollen", "Fungus",
    "Mycelium", "Spore", "Lichen", "Bark", "Cyst", "Coral", "Anemone", "Polyp",
    "Medusa", "Chrysalis", "Embryo", "Sphere", "Cube", "Helix", "Torus",
    "Cylinder", "Cone", "Prism", "Disc", "Circle", "Square", "Triangle", "Polygon",
    "Hexagon", "Octagon", "Vertex", "Axis", "Vector", "Tangent", "Arc", "Spiral",
    "Node", "Intersection", "Planes", "Symmetry", "Asymmetry", "Volume", "Mass",
    "Density", "Void", "Infinity", "Horizon", "Parabola", "Hyperbola", "Ellipse",
    "Fractal", "Crystal", "Matrix",
    // Arkitektur & struktur
    "Alcove", "Aqueduct", "Arcade", "Battlement", "Belfry", "Canopy", "Catacomb",
    "Causeway", "Cloister", "Colonnade", "Crypt", "Cupola", "Drawbridge", "Dungeon",
    "Embankment", "Escarpment", "Fortification", "Gatehouse", "Granary", "Grotto",
    "Keep", "Labyrinth", "Mausoleum", "Minaret", "Nave", "Parapet", "Passageway",
    "Pier", "Portico", "Rampart", "Sepulchre", "Terrace", "Turret", "Vestibule",
    "Watchtower", "Archway", "Cellar", "Chamber", "Chimney", "Cistern", "Courtyard",
    "Fissure", "Floorplan", "Hearth", "Niche", "Partition", "Pinnacle", "Podium",
    "Recess", "Reservoir", "Stairwell", "Steeple",
    // Landskaber & geologi
    "Archipelago", "Atoll", "Badlands", "Caldera", "Canyon", "Cavern", "Cliff",
    "Crater", "Delta", "Dune", "Fjord", "Floodplain", "Glacier", "Gorge", "Icefield",
    "Inlet", "Karst", "Lagoon", "Lava", "Mesa", "Moraine", "Outcrop", "Peninsula",
    "Plateau", "Reef", "Ridge", "Rift", "Shoreline", "Sinkhole", "Steppe", "Tundra",
    "Valley", "Volcano", "Abyss", "Bedrock", "Bluff", "Chasm", "Crevasse", "Fault",
    "Floe", "Geyser", "Headland", "Lowland", "Marshland", "Permafrost", "Ravine",
    "Scree", "Sediment", "Stratum", "Trench", "Wasteland",
    // Dyr & dyredele
    "Beetle", "Crow", "Eel", "Falcon", "Fox", "Hare", "Hawk", "Heron", "Hornet",
    "Hyena", "Jackal", "Jaguar", "Lynx", "Mantis", "Mole", "Osprey", "Otter",
    "Owl", "Python", "Raven", "Salamander", "Scorpion", "Serpent", "Shark", "Stag",
    "Stallion", "Swan", "Viper", "Vulture", "Wolf", "Albatross", "Bat", "Bison",
    "Crane", "Dragonfly", "Elk", "Firefly", "Ibis", "Kraken", "Lamprey", "Manta",
    "Marlin", "Moose", "Narwhal", "Panther", "Pelican", "Porcupine", "Rhino",
    "Swordfish", "Tapir", "Wolverine",
    // Himmel & vejr
    "Aurora", "Blizzard", "Cyclone", "Eclipse", "Fog", "Hail", "Lightning",
    "Maelstrom", "Mist", "Storm", "Tempest", "Thunder", "Twilight", "Whirlpool",
    "Afterglow", "Atmosphere", "Cloudbank", "Cumulonimbus", "Darkness", "Dusk",
    "Flare", "Gale", "Haze", "Overcast", "Penumbra", "Radiance", "Rainfall",
    "Snowdrift", "Solstice", "Squall", "Stratosphere", "Sunspot", "Vortex", "Zenith",
    // Menneskelige former & figurer
    "Effigy", "Figure", "Gesture", "Mask", "Phantom", "Posture", "Profile",
    "Remnant", "Silhouette", "Specter", "Statue", "Apparition", "Avatar", "Body",
    "Deity", "Form", "Ghost", "Idol", "Image", "Impression", "Outline", "Presence",
    "Projection", "Reflection", "Shadow", "Shape", "Trace", "Vision"
  ];

  const secondaries = [
    // Originale
    "Erosion", "Decay", "Fluidity", "Suspension", "Gravity", "Absence", "Presence",
    "Resonance", "Entropy", "Mirage", "Echo", "Mutation", "Collision", "Depth",
    "Transparency", "Explosion", "Movement", "Curvature", "Compression", "Expansion",
    "Rotation", "Reflection", "Diffusion", "Liquid", "Gaseous", "Brittle", "Malleable",
    "Static", "Kinetic", "Organic", "Synthetic", "Porous", "Dense", "Fragile", "Rigid",
    "Elastic", "Weathered", "Frozen", "Burning", "Melting", "Weightless", "Heavy",
    "Radiating", "Collapsing", "Converging", "Diverging", "Pulsating", "Fading",
    "Ascending", "Descending", "Vibrating", "Tectonic", "Strata", "Silence", "Isolation",
    "Connection", "Conflict", "Harmony", "Rebellion", "Legacy", "Origin", "Destiny",
    "Balance", "Paradox", "Aura", "Ritual", "Subconscious", "Threshold", "Velocity",
    "Ethereal", "Savage", "Pure", "Sacred", "Mystic", "Infinite", "Ephemeral", "Eternal",
    "Primal", "Ancient", "Futuristic", "Nomad", "Zenith", "Abyss", "Summit", "Horizon",
    "Inertia", "Lumen", "Unity", "Liminal", "Obscura", "Spectral", "Ghostly", "Radiant",
    "Obscure", "Hidden", "Exposed", "Raw", "Living", "Dying", "Haunted", "Blessed",
    "Corrupted", "Overwhelming", "Melancholy", "Euphoria", "Solitude", "Void",
    "Distortion", "Stagnation", "Metamorphosis", "Nocturnal", "Clandestine", "Celestial",
    "Abyssal", "Sanctuary", "Chaos", "Order", "Serenity", "Tension", "Fragility",
    "Momentum", "Desolation", "Vitality", "Obsidian", "Nebulous", "Transcendence",
    "Solace", "Rupture",
    // Tilstande & processer
    "Accumulation", "Calcification", "Carbonization", "Condensation", "Corrosion",
    "Crystallisation", "Decomposition", "Deformation", "Degradation", "Dissolution",
    "Evaporation", "Fermentation", "Fossilisation", "Fragmentation", "Glaciation",
    "Hardening", "Ignition", "Immersion", "Incineration", "Liquefaction", "Oxidation",
    "Petrification", "Precipitation", "Proliferation", "Saturation", "Sedimentation",
    "Solidification", "Stratification", "Sublimation", "Weathering", "Absorption",
    "Agitation", "Amplification", "Atrophy", "Bleaching", "Blooming", "Branching",
    "Clustering", "Coagulation", "Combustion", "Contraction", "Diffraction", "Dispersion",
    "Distillation", "Fission", "Fusion", "Germination", "Grafting", "Inversion",
    "Migration", "Morphing", "Oscillation", "Propagation", "Pulsation", "Radiation",
    "Replication", "Scattering", "Seeping", "Shattering", "Splintering", "Spreading",
    "Surging", "Warping",
    // Kvaliteter & egenskaber
    "Abrasive", "Archaic", "Austere", "Barren", "Bleak", "Caustic", "Colossal",
    "Covert", "Cryptic", "Desolate", "Diffuse", "Dormant", "Erratic", "Ferocious",
    "Formless", "Fractured", "Hollow", "Immense", "Inert", "Latent", "Luminous",
    "Muted", "Oblique", "Opaque", "Pallid", "Primordial", "Quiet", "Rugged", "Scarred",
    "Serene", "Stark", "Submerged", "Subtle", "Turbulent", "Vast", "Volatile", "Worn",
    "Abandoned", "Acute", "Asymmetric", "Boundless", "Collapsed", "Consumed", "Corroded",
    "Cracked", "Crumbling", "Deformed", "Divided", "Drowned", "Elemental", "Enormous",
    "Eroded", "Faint", "Fierce", "Glowing", "Jagged", "Layered", "Loose", "Lost",
    "Massive", "Molten", "Monolithic", "Murky", "Nameless", "Overgrown", "Parallel",
    "Petrified", "Rough", "Shattered", "Shifting", "Silent", "Skeletal", "Slow",
    "Smouldering", "Soft", "Solid", "Split", "Suspended", "Tangled", "Thick", "Thin",
    "Timeless", "Twisted", "Uneven", "Unknown", "Unmarked", "Withered",
    // Følelser & stemninger
    "Anguish", "Anticipation", "Catharsis", "Clarity", "Contemplation", "Dread",
    "Elegy", "Emptiness", "Foreboding", "Grief", "Longing", "Nostalgia", "Reverence",
    "Stillness", "Surrender", "Unease", "Wonder", "Yearning", "Acceptance", "Alienation",
    "Awe", "Betrayal", "Bitterness", "Burden", "Confusion", "Courage", "Craving",
    "Defiance", "Desire", "Devotion", "Dissonance", "Ecstasy", "Exile", "Exhaustion",
    "Fear", "Frenzy", "Guilt", "Hope", "Humility", "Hunger", "Impermanence",
    "Insignificance", "Intimacy", "Invisibility", "Joy", "Mourning", "Obsession",
    "Panic", "Peace", "Rage", "Regret", "Rejection", "Release", "Remorse", "Resilience",
    "Sorrow", "Spite", "Terror", "Trust", "Uncertainty", "Vulnerability", "Wrath",
    // Objekter & redskaber
    "Anvil", "Blade", "Bolt", "Chain", "Chisel", "Clasp", "Coil", "Compass", "Gear",
    "Hammer", "Hinge", "Hook", "Key", "Knot", "Latch", "Lever", "Nail", "Needle",
    "Pin", "Pulley", "Rivet", "Rod", "Rope", "Saw", "Screw", "Shard", "Spike",
    "Spring", "Thread", "Wire", "Anchor", "Arrow", "Axle", "Cage", "Cartridge",
    "Clamp", "Cog", "Dial", "Edge", "Filament", "Flask", "Funnel", "Girder", "Grate",
    "Handle", "Hatch", "Jar", "Loom", "Mold", "Pendulum", "Plank", "Plate", "Probe",
    "Rack", "Rail", "Ring", "Shaft", "Socket", "Spindle", "Stamp", "Strut", "Tube",
    "Valve", "Wheel", "Wrench",
    // Naturlige objekter
    "Ash", "Bone", "Branch", "Cinder", "Cloud", "Dew", "Dust", "Ember", "Feather",
    "Foam", "Frost", "Ice", "Mud", "Rain", "Sand", "Smoke", "Snow", "Soil", "Soot",
    "Stone", "Tide", "Wave", "Wind", "Algae", "Amber", "Blossom", "Boulder", "Brook",
    "Burrow", "Cave", "Cobweb", "Crag", "Creek", "Crown", "Fern", "Flint", "Husk",
    "Kelp", "Leaf", "Log", "Moss", "Nest", "Pebble", "Pool", "Reed", "Rock", "Rubble",
    "Rust", "Shrub", "Slime", "Stump", "Swamp", "Trunk", "Twig", "Vine", "Web",
    // Abstrakte objekter
    "Archive", "Blueprint", "Cipher", "Code", "Document", "Glyph", "Index", "Map",
    "Mark", "Pattern", "Record", "Score", "Script", "Signal", "Symbol", "Trace",
    "Weight", "Algorithm", "Codex", "Diagram", "Draft", "Equation", "Formula",
    "Geometry", "Grammar", "Grid", "Hypothesis", "Icon", "Instruction", "Interface",
    "Label", "Language", "Layer", "Legend", "Logic", "Manifesto", "Measure", "Model",
    "Myth", "Narrative", "Network", "Notation", "Number", "Outline", "Parameter",
    "Protocol", "Reference", "Register", "Rule", "Schema", "Sequence", "Series",
    "Sign", "Sketch", "System", "Template", "Text", "Theory", "Variable",
    // Astronomiske
    "Comet", "Eclipse", "Moon", "Nebula", "Nova", "Orbit", "Pulse", "Shadow", "Star",
    "Sun", "Aphelion", "Asteroid", "Blackhole", "Constellation", "Corona", "Cosmos",
    "Galaxy", "Interstellar", "Magnetar", "Meteor", "Parallax", "Perihelion", "Photon",
    "Pulsar", "Quasar", "Singularity", "Supernova", "Wormhole",
    // Dyr & insekter
    "Claw", "Fang", "Fur", "Hide", "Hoof", "Horn", "Leech", "Locust", "Mane", "Moth",
    "Pelt", "Slug", "Sparrow", "Spider", "Squid", "Swallow", "Talon", "Toad", "Tusk",
    "Wasp", "Worm", "Wren", "Burrow", "Colony", "Drone", "Hive", "Larva", "Migration",
    "Molt", "Pack", "Parasite", "Predator", "Prey", "Quill", "Scent", "Sting", "Swarm",
    "Trail", "Venom",
    // Lyd & frekvens
    "Chord", "Dissonance", "Drone", "Frequency", "Hum", "Interference", "Murmur",
    "Noise", "Pitch", "Reverberation", "Rumble", "Static", "Tone", "Tremor",
    "Vibration", "Waveform", "Whisper", "Amplitude", "Bass", "Cadence", "Crescendo",
    "Feedback", "Interval", "Overtone", "Rhythm", "Spectrum", "Surge", "Timbre",
    "Wavelength",
    // Tid & hukommelse
    "Afterimage", "Aftermath", "Chronicle", "Cycle", "Epoch", "Era", "Fossil",
    "Generation", "Imprint", "Interval", "Layering", "Loop", "Memory", "Moment",
    "Passage", "Remnant", "Repetition", "Residue", "Sequence", "Age", "Before",
    "Blur", "Burial", "Continuity", "Delay", "Disappearance", "Distance", "Duration",
    "Endurance", "Extinction", "Fade", "Forgetting", "Impression", "Inscription",
    "Instant", "Lapse", "Permanence", "Phase", "Preservation", "Return", "Revision",
    "Ruin", "Scar", "Sediment", "Sleep", "Stasis", "Succession", "Vestige", "Witness",
    // Bevægelse & kraft
    "Acceleration", "Cascade", "Current", "Displacement", "Drift", "Flow", "Force",
    "Friction", "Impact", "Pressure", "Pull", "Push", "Release", "Resistance", "Shift",
    "Thrust", "Torque", "Trajectory", "Turbulence", "Bounce", "Break", "Burst",
    "Centrifuge", "Charge", "Convergence", "Crack", "Crush", "Curve", "Deflection",
    "Detonation", "Deviation", "Drive", "Drop", "Erupt", "Escalation", "Extension",
    "Fall", "Glide", "Groundswell", "Impulse", "Jolt", "Launch", "Leap", "Lift",
    "Outburst", "Overflow", "Pierce", "Pivot", "Plunge", "Recoil", "Reversal", "Rise",
    "Roll", "Rush", "Shockwave", "Slide", "Spin", "Strike", "Sweep", "Swing", "Twist",
    "Unravel", "Uplift", "Whirl"
  ];

  const colorSeeds = [
    "#E63946", "#F1FAEE", "#A8DADC", "#457B9D", "#1D3557",
    "#FFBE0B", "#FB5607", "#FF006E", "#8338EC", "#3A86FF",
    "#264653", "#2A9D8F", "#E9C46A", "#F4A261", "#E76F51",
    "#00F5D4", "#00BBF9", "#9B5DE5", "#F15BB5", "#1A1A1A",
    "#6B705C", "#A5A58D", "#B7B7A4", "#FFE8D6", "#CB997E",
    "#D62828", "#F77F00", "#FCBF49", "#EAE2B7", "#003049"
  ];

  // ─── 2. INIT ───────────────────────────────────────────────

  function init() {
    // Finder wrapperen for denne specifikke section
    const wrapper = document.querySelector('.aig-page-wrapper');
    if (!wrapper) return;

    // Undgår dobbelt-initialisering
    if (wrapper.dataset.aigInit === 'true') return;
    wrapper.dataset.aigInit = 'true';

    // DOM-referencer
    const soundToggle   = wrapper.querySelector('#aig-sound-toggle');
    const soundText     = wrapper.querySelector('#aig-sound-text');
    const themeToggle   = wrapper.querySelector('#aig-theme-toggle');
    const toggleText    = wrapper.querySelector('#aig-toggle-text');
    const primaryEl     = wrapper.querySelector('#aig-primary');
    const secondaryEl   = wrapper.querySelector('#aig-secondary');
    const shadeDisplay  = wrapper.querySelector('#aig-shade-display');
    const mainBtn       = wrapper.querySelector('#aig-main-btn');
    const btnLabel      = wrapper.querySelector('#aig-btn-label');
    const lockPrimary   = wrapper.querySelector('#aig-lock-primary');
    const lockSecondary = wrapper.querySelector('#aig-lock-secondary');
    const lockPalette   = wrapper.querySelector('#aig-lock-palette');

    // State
    let isMuted          = false;
    let firstTime        = true;
    let isShuffling      = false;
    let audioCtx         = null;
    let primaryLocked    = false;
    let secondaryLocked  = false;
    let paletteLocked    = false;

    // Ryd palette ved load
    shadeDisplay.innerHTML = '';

    // ─── 3. AUDIO ─────────────────────────────────────────────
    // AudioContext oprettes ved første brugerinteraktion
    // for at overholde browser autoplay policies

    function getAudioCtx() {
      if (!audioCtx) {
        audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      }
      return audioCtx;
    }

    function playClick(freq) {
      freq = freq || 150;
      if (isMuted) return;

      try {
        const ctx = getAudioCtx();
        if (ctx.state === 'suspended') ctx.resume();

        const osc  = ctx.createOscillator();
        const gain = ctx.createGain();

        osc.type = 'sine';
        osc.frequency.setValueAtTime(freq, ctx.currentTime);
        gain.gain.setValueAtTime(0.04, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.12);

        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start();
        osc.stop(ctx.currentTime + 0.12);
      } catch (e) {
        // AudioContext understøttes ikke — ignorer lydmæssige fejl
      }
    }

    // ─── 4. TOGGLE HANDLERS ───────────────────────────────────

    soundToggle.addEventListener('click', function () {
      isMuted = !isMuted;
      soundText.textContent = isMuted ? 'SOUND OFF' : 'SOUND ON';
      if (isMuted) {
        soundToggle.classList.add('muted');
      } else {
        soundToggle.classList.remove('muted');
        playClick(400);
      }
    });

    themeToggle.addEventListener('click', function () {
      const isDark   = wrapper.dataset.theme === 'dark';
      const next     = isDark ? 'light' : 'dark';
      wrapper.dataset.theme = next;
      toggleText.textContent = next === 'dark' ? 'LIGHT MODE' : 'DARK MODE';
      playClick(350);
    });

    // ─── 4b. LOCK HANDLERS ────────────────────────────────────

    function toggleLock(btn, isLocked) {
      isLocked = !isLocked;
      if (isLocked) {
        btn.classList.add('locked');
      } else {
        btn.classList.remove('locked');
      }
      playClick(isLocked ? 600 : 300);
      return isLocked;
    }

    lockPrimary.addEventListener('click', function () {
      primaryLocked = toggleLock(lockPrimary, primaryLocked);
    });

    lockSecondary.addEventListener('click', function () {
      secondaryLocked = toggleLock(lockSecondary, secondaryLocked);
    });

    lockPalette.addEventListener('click', function () {
      paletteLocked = toggleLock(lockPalette, paletteLocked);
    });

    // ─── 5. LOGIC ─────────────────────────────────────────────

    function getRandom(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    function getRandomPalette() {
      const base = getRandom(colorSeeds);
      const sec  = getRandom(colorSeeds);
      return [base, sec, '#1A1A1A', '#EEEEEE'].sort(function () {
        return Math.random() - 0.5;
      });
    }

    function updateColors(palette) {
      shadeDisplay.innerHTML = palette.map(function (hex) {
        return (
          '<div class="aig-shade-item">' +
            '<div class="aig-shade-circle" style="background-color:' + hex + '"></div>' +
            '<span class="aig-hex-code">' + hex + '</span>' +
          '</div>'
        );
      }).join('');
    }

    function generate() {
      if (isShuffling) return;
      isShuffling = true;
      mainBtn.disabled = true;

      if (firstTime) {
        btnLabel.textContent = 'GENERATE NEW IDEA';
        firstTime = false;
      }

      var counter    = 0;
      var totalSteps = 14;

      function shuffle() {
        if (!primaryLocked)   primaryEl.textContent   = getRandom(primaries);
        if (!secondaryLocked) secondaryEl.textContent = getRandom(secondaries);
        if (!paletteLocked)   updateColors(getRandomPalette());
        playClick(180 + counter * 35);

        counter++;
        if (counter < totalSteps) {
          var delay = 40 + Math.pow(counter, 2.5);
          setTimeout(shuffle, delay);
        } else {
          mainBtn.disabled = false;
          isShuffling = false;
          playClick(500);
        }
      }

      shuffle();
    }

    // Knap event
    mainBtn.addEventListener('click', generate);
  }

  // ─── 6. START ─────────────────────────────────────────────
  // Kører ved DOMContentLoaded (eller straks hvis DOM allerede er klar)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor live-reload support
  document.addEventListener('shopify:section:load', init);

})();